import { MenuItem, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import UpdateInspectionStatusModal from '../../forms/InspectionStatus/upgrade/UpdateInspectionStatusModal';
import { RenderIf } from '../RenderIf/RenderIf';
import { TableActionMenu } from '../Table/TableActionMenu';
const InspectionsTableActionMenu = ({ onInspectionMutated, inspection, }) => {
    const changeStatusModal = useDisclosure();
    return (React.createElement(React.Fragment, null,
        React.createElement(TableActionMenu, null,
            React.createElement(MenuItem, { "data-testid": "inspection_table_action_menu__change_status", onClick: (e) => {
                    e.stopPropagation();
                    changeStatusModal.onOpen();
                } }, localise('CHANGE_STATUS'))),
        React.createElement(RenderIf, { condition: changeStatusModal.isOpen },
            React.createElement(UpdateInspectionStatusModal, { isOpen: true, inspection: inspection, onClose: changeStatusModal.onClose, onSuccess: () => {
                    changeStatusModal.onClose();
                    onInspectionMutated(inspection);
                } }))));
};
export default InspectionsTableActionMenu;
